// extracted by mini-css-extract-plugin
export default {"innerContainer":"editions_innerContainer__Pp2pS","editions":"editions_editions__jijaU"};